import type { FaireProductEntity } from "../../entity_types/product";

export const p_vy2pj2f29d: FaireProductEntity = {
  token: "p_vy2pj2f29d",
  type: "product",
  name: "WORRY NOT Herbal Tea Blend - Lavender Buds & Chamomile",
  brandName: "Loveyenergy & Blessings",
  imageUrl:
    "https://cdn.faire.com/fastly/8bd43990ec6df2264c5552e984692041e617e0ceae85f83d3860eaaae83b16ea.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2113def909b7d09c02dea95fced8b1bfccd463c0cde3d298765bfb2d0078cbff.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
